import { ViewportScroller } from '@angular/common';
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { isNullOrUndefined } from '@mvneco/eb-core';
import { Subscription, Observable } from 'rxjs';
import { delay, filter, map, tap } from 'rxjs/operators';
import { ClickService } from './modules/activation/services/click.service';
import { PendingService } from './services/pending.service';
import { AppFeaturesService } from '@mvneco/app-features';
import { DisableScreenService } from './services/disable-screen.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('footnote_accordion') footnoteAccordion: ElementRef;
  @ViewChild('footnote_link') footnoteLink: ElementRef;
  @ViewChild('header') header: ElementRef;

  @ViewChildren('footnote') footnotes: QueryList<ElementRef>;

  private subscriptions: Subscription[] = new Array<Subscription>();
  public appTitle: string;

  public pending$ = this.pendingService.pending$.pipe(delay(0));
  
  constructor(
    private pendingService: PendingService,
    private clickService: ClickService,
    private viewportScroller: ViewportScroller,
    private router: Router,
    public appFeatures: AppFeaturesService,
    private disableScreenService: DisableScreenService, // EB-17970

  ) {
    router.events.pipe(
      filter(event => event instanceof NavigationEnd)).
      subscribe((event: NavigationEnd) => {

        // Angular v7+
        this.viewportScroller.scrollToPosition([0, 0]);
      }
    );
  }

  get disableClick$() { // EB-17970
    return this.disableScreenService.disableScreen$;
  }

  ngOnInit() {

    // If the script isn't loaded in this way,
    // JQuery functions and other code will not work!!!
    this.loadScript('assets/js/alditalk_responsive_4-1-0v1.js');

    // Reactivate accessibility immediately in case popup dialog is not shown
    this.subscriptions.push(
      this.appFeatures.appType$.pipe(
        delay(0),
        tap(res => {
          if (res === 'app' || res === 'ccs') {
            const appRoot = document.querySelector('app-root') as HTMLElement;
            if (appRoot) {
              appRoot.removeAttribute('inert');

              // Optional: force reflow to ensure browser updates accessibility tree
              void appRoot.offsetHeight;
            }
          }
        })
      ).subscribe()
    );
  }

  ngAfterViewInit() {

    this.viewportScroller.setOffset([0, this.header.nativeElement.offsetHeight]);

    this.subscriptions.push(
      this.clickService.clickSubject.pipe(
        filter(res => res?.target?.href.includes('simcard/reg/options#footnote_') || res?.target?.href.includes('simcard/reg/confirm#footnote_')),
        tap(res => {
          res.preventDefault();
          this.footnotes.forEach(fn => fn.nativeElement.style = '');
          if (!this.footnoteAccordion.nativeElement.classList.contains('is-open')) {
            this.footnoteLink.nativeElement.click();
          }
        }),
        map(res => res?.target?.href),
        map(res => res.split('#')[1]),
        map(res => this.footnotes.filter(fn => fn.nativeElement.id === res)?.[0]?.nativeElement),
        tap(res => console.log(res)),
        filter(res => !isNullOrUndefined(res)),
        tap(res => this.viewportScroller.scrollToAnchor(res.id)),
        tap(res => res.style = 'outline: 1px solid #c51718;'),
      ).subscribe()
    );

    this.subscriptions.push(
      this.router.events.pipe(
        tap(() => {
          // console.log('A this.footnoteAccordion:', this.footnoteAccordion);
          // console.log('A this.footnoteLink:', this.footnoteLink);
          // console.log('A this.footnotes:', this.footnotes);

          if (this.footnoteAccordion.nativeElement.classList.contains('is-open')) {
            this.footnoteLink.nativeElement.click();
          }
          this.footnotes.forEach(fn => fn.nativeElement.style = '');
        }),
      ).subscribe()
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => { sub.unsubscribe(); });
  }

  get appFeaturesAppType(): Observable<string> {
    return this.appFeatures.appType$;
  }

  public onFootnoteElementClicked(event: UIEvent) {
    // console.log('\n\nonFootnoteElementClicked event:', event);
    // console.log('B this.footnoteAccordion:', this.footnoteAccordion);
    // console.log('B this.footnoteAccordion?.nativeElement?.classList:', this.footnoteAccordion?.nativeElement?.classList);
    // console.log('B this.footnoteLink:', this.footnoteLink);
    // console.log('B this.footnotes:', this.footnotes);
    // this.footnotes.forEach(fn => console.log(fn.nativeElement.style));

    const paneExpanded = this.footnoteAccordion.nativeElement.classList.contains('is-open');
    // console.log('is-open:', paneExpanded);


    if (paneExpanded) {
      // console.log('A1 paneExpanded is truthy');
      this.footnoteLink.nativeElement.click();
      this.footnotes.forEach(fn => fn.nativeElement.style = '');
      this.footnoteAccordion.nativeElement.classList.remove('is-open');
    } else {
      // console.log('A2 paneExpanded is falsy');
      event.preventDefault();
      this.footnotes.forEach(fn => fn.nativeElement.style = 'is-open');
      this.footnoteLink.nativeElement.click();
      this.footnoteAccordion.nativeElement.classList.add('is-open');
      // console.log('B2 this.footnoteAccordion?.nativeElement?.classList:', this.footnoteAccordion?.nativeElement?.classList);
    }
  }

  private loadScript(url) {
    const node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(node);
  }
}
